import React from "react";
import footerStyles from "./../styles/footer.module.css";

const Footer = () => {
  return <div className={footerStyles.footer}>© 2023 AI FORENSICS</div>;
};

export default Footer;
